import api from "@/lib/axios";

export const roleService = {
  async getAllRoles(page = 1, searchParams = {}) {
    // Build query string with searchParams
    let queryString = `page=${page}`;
    
    // Add title search param if provided
    if (searchParams.title) {
      queryString += `&title=${encodeURIComponent(searchParams.title)}`;
    }
    
    const response = await api.get(`/v1/admin/roles?${queryString}`);
    return response.data;
  },

  async getRole(id) {
    const response = await api.get(`/v1/admin/roles/${id}`);
    return response.data;
  },

  async createRole(data) {
    const response = await api.post('/v1/admin/roles', data);
    return response.data;
  },

  async updateRole(id, data) {
    const response = await api.put(`/v1/admin/roles/${id}`, data);
    return response.data;
  },

  async deleteRole(id) {
    const response = await api.delete(`/v1/admin/roles/${id}`);
    return response.data;
  }
}; 